var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-impressao-titulo"},[_c('h2',[_vm._v("\n    Impressão\n  ")]),_c('div',{staticClass:"modal-impressao-fecha",on:{"click":_vm.handleModalClose}},[_c('font-awesome-icon',{attrs:{"icon":"times"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }